import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';

export const networkGetGamePreviewTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GamePreviewType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchGamePreviewTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['game-preview-type-list', pageIndex],
    queryFn: () => networkGetGamePreviewTypeList(pageIndex, pageSize),
  });
}

export const networkGetGamePreviewList = async (data, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GamePreview/List/${pageIndex}/${pageSize}`, data);
  return res;
};

export function useFetchGamePreviewList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['game-preview-list', pageIndex, payload],
    queryFn: () => networkGetGamePreviewList(payload, pageIndex, pageSize),
  });
}

export const networkCreateGamePreview = async (data) => {
  const res = await axiosInstance.post('GamePreview/Insert', data);
  return res;
};

export const networkUpdateGamePreview = async (gamePreviewId, data) => {
  const res = await axiosInstance.post(`GamePreview/Update/${gamePreviewId}`, data);
  return res;
};

export const networkRemoveGamePreview = async (gamePreviewId) => {
  const res = await axiosInstance.post(`GamePreview/Remove/${gamePreviewId}`);
  return res;
};

// ------------------------------------------------------------------

// GameJoinHashTag

export const networkCreateGameJoinHashTag = async (data) => {
  const res = await axiosInstance.post('GameJoinHashTag/Insert', data);
  return res;
};

export const networkRemoveGameJoinHashTag = async (gameJoinHashTagId) => {
  const res = await axiosInstance.post(`GameJoinHashTag/Remove/${gameJoinHashTagId}`);
  return res;
};

// ------------------------------------------------------------------

// GameWikiData

export const networkCreateGameWiki = async (data) => {
  const res = await axiosInstance.post('GameWiki/Insert', data);
  return res;
};

export const networkRemoveGameWiki = async (gameWikiId) => {
  const res = await axiosInstance.post(`GameWiki/Remove/${gameWikiId}`);
  return res;
};

export const networkUpdateGameWiki = async (gameWikiId, data) => {
  const res = await axiosInstance.post(`GameWiki/Update/${gameWikiId}`, data);
  return res;
};

// ------------------------------------------------------------------

// GameJoinTag

export const networkCreateGameJoinTag = async (data) => {
  const res = await axiosInstance.post('GameJoinTag/Insert', data);
  return res;
};

export const networkRemoveGameJoinTag = async (gameJoinTagId) => {
  const res = await axiosInstance.post(`GameJoinTag/Remove/${gameJoinTagId}`);
  return res;
};

// ------------------------------------------------------------------

// ArtistsTypeJoinContent

export const networkGetArtistsTypeJoinContentList = async (data, pageIndex = 0, pageSize = 100) => {
  const res = await axiosInstance.post(`GamePreviewType/List/${pageIndex}/${pageSize}`, data);
  return res;
};

export function useFetchArtistsTypeJoinContentList(data, pageIndex = 0, pageSize = 100) {
  return useQuery({
    queryKey: ['artists-type-join-content-list', data],
    queryFn: () => networkGetArtistsTypeJoinContentList(data, pageIndex, pageSize),
  });
}

export const networkCreateGameJoinArtist = async (data) => {
  const res = await axiosInstance.post('GameJoinArtist/Insert', data);
  return res;
};

export const networkRemoveGameJoinArtist = async (gameJoinArtistId) => {
  const res = await axiosInstance.post(`GameJoinArtist/Remove/${gameJoinArtistId}`);
  return res;
};
